/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen.reducer';

export const RegimenDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenEntity = useAppSelector(state => state.regimen.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimen.detail.title">Regimen</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimen.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.regimen.name">Name</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.regimen.description">Description</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.description}</dd>
          <dt>
            <span id="noOfCycles">
              <Translate contentKey="tinyMedicRestApp.regimen.noOfCycles">No Of Cycles</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.noOfCycles}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimen.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimen.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimen.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimen.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimen.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenEntity.timestampEntry}</dd>
          <dt>
            <span id="global">
              <Translate contentKey="tinyMedicRestApp.regimen.global">Global</Translate>
            </span>
            <UncontrolledTooltip target="global">
              <Translate contentKey="tinyMedicRestApp.regimen.help.global" />
            </UncontrolledTooltip>
          </dt>
          <dd>{regimenEntity.global ? 'true' : 'false'}</dd>
          <dt>
            <span id="sharedInternally">
              <Translate contentKey="tinyMedicRestApp.regimen.sharedInternally">Shared Internally</Translate>
            </span>
            <UncontrolledTooltip target="sharedInternally">
              <Translate contentKey="tinyMedicRestApp.regimen.help.sharedInternally" />
            </UncontrolledTooltip>
          </dt>
          <dd>{regimenEntity.sharedInternally ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimen.templateComponent">Template Component</Translate>
          </dt>
          <dd>{regimenEntity.templateComponent ? regimenEntity.templateComponent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimen.doctor">Doctor</Translate>
          </dt>
          <dd>{regimenEntity.doctor ? regimenEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimen.hospital">Hospital</Translate>
          </dt>
          <dd>{regimenEntity.hospital ? regimenEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen/${regimenEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenDetail;
